import yoigoParticular1 from './yoigoParticular1';

export default {
    yoigoParticular1,
};